import { IS_STANDALONE } from "./standalone/config";
import PlatformApp from "./platform_spaces/PlatformApp";
import StandaloneApp from "./standalone/StandaloneApp";

function App() {
  return IS_STANDALONE ? <StandaloneApp /> : <PlatformApp />;
}

export default App;
